import React, { useState } from 'react';
import useOutsideAlerter from 'react-scale/components/audits/SpeedAudit/v2/hooks/useOutsideAlerter';
import CreatableSelect from 'react-select-3/creatable';
import { ChatBulkAuditTaskAction } from '@scale/shared/types/corp/attemptAudit';
import { ValueType, OptionTypeBase } from 'react-select-3/src/types';

interface CreatableSelectOptionType extends OptionTypeBase {
  value: string;
  label: string;
}

const actionOptions = [
  {
    label: 'Keep in current level (no action)',
    value: ChatBulkAuditTaskAction.KEEP_IN_CURRENT_LEVEL,
  },
  {
    label: 'Move forward 1 layer',
    value: ChatBulkAuditTaskAction.MOVE_FORWARD_ONE_LAYER,
  },
  {
    label: 'Clear responses and SBQ (to attempt)',
    value: ChatBulkAuditTaskAction.SEND_BACK_TO_QUEUE_CLEAR_RESPONSES,
  },
  {
    label: 'Send to specific review level (keep responses)',
    value: ChatBulkAuditTaskAction.SEND_BACK_TO_QUEUE_KEEP_RESPONSES,
  },
];

const findSelectedOption = (value: string): CreatableSelectOptionType | undefined => {
  return actionOptions.find(option => option.value === value);
};

interface ChatBulkAuditTaskActionPickerProps {
  selectedTaskAction: string;
  toggleChoose: (taskAction: string | null) => void;
  isDisabled?: boolean;
}

const ChatBulkAuditTaskActionPicker: React.FC<ChatBulkAuditTaskActionPickerProps> = ({
  selectedTaskAction,
  toggleChoose,
  isDisabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = React.useRef<HTMLDivElement | null>(null);
  useOutsideAlerter(wrapperRef, () => setOpen(false));

  const selectedOption = findSelectedOption(selectedTaskAction);

  const taskActionPickerClassname =
    'task-action-picker' + (open ? ' task-action-picker--open' : '');

  return (
    <div className={taskActionPickerClassname} ref={wrapperRef}>
      <style jsx>{`
        .task-action-picker {
          position: relative;
          display: flex;
          flex-direction: column;
        }
        .select-head {
          border: 1px solid var(--color-LightSkyBlue);
          padding: 7px 16px;
          border-radius: 8px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .select-head:hover {
          background: #eee;
        }

        .task-action-picker.task-action-picker--open .select-head {
          color: var(--color-primary);
          border: 1px solid var(--color-primary);
        }

        .opts-wrapper {
          display: flex;
          flex-direction: column;
          width: 100%;
          min-width: 200px;
          border-radius: 8px;
        }

        .opts-wrapper:hover {
          cursor: pointer;
        }

        .choose-error-category {
          padding: 6px 10px;
        }

        .choose-error-category:hover {
          background: #eee;
          cursor: pointer;
        }

        .choose-error-category.choose-error-category--on {
          background: #eee;
          border-bottom: 2px solid var(--color-primary);
        }
      `}</style>
      <div className="opts-wrapper">
        <div>
          <CreatableSelect
            fullWidth
            placeholder="Select an action for this task"
            isMulti={false}
            isDisabled={isDisabled}
            isValidNewOption={() => false}
            options={actionOptions}
            value={selectedOption || null}
            menuMaxHeight={80}
            onChange={(newValue: ValueType<CreatableSelectOptionType>) => {
              if (!newValue) {
                toggleChoose(null);
              } else {
                toggleChoose((newValue as CreatableSelectOptionType).value);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatBulkAuditTaskActionPicker;
